import { createContext, FC, ReactNode, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";

export const ClientContext = createContext("");

export const useClientContext = () => useContext(ClientContext);

export const ClientContextProvider: FC<{ children: ReactNode | ReactNode[] }> = ({ children }) => {
  const [ client, setClient ] = useState("");
  const { search } = useLocation();

  useEffect(() => {
    const newClient = new URLSearchParams(search).get("client");
    if (newClient) {
      setClient(newClient)
    }
  }, [ search ]);

  return (
    <ClientContext.Provider value={client || ""}>
      {children}
    </ClientContext.Provider>
  );
};



